// frontend/src/contexts/AssetDetailContext.js
/**
 * Asset Detail Context – shared open/close for AssetDetailModal across asset-admin.
 * Used by: Layout (post-scan), Assets (table row), and any future triggers.
 */

import React, { createContext, useContext, useState, useCallback } from 'react';
import AssetDetailModal from '../components/AssetDetailModal';

const AssetDetailContext = createContext(null);

export const useAssetDetail = () => {
  const ctx = useContext(AssetDetailContext);
  if (!ctx) throw new Error('useAssetDetail must be used within AssetDetailProvider');
  return ctx;
};

export const AssetDetailProvider = ({ children }) => {
  const [state, setState] = useState({
    open: false,
    assetId: null,
    initialAsset: null,
  });

  const openAssetDetail = useCallback((assetId, initialAsset) => {
    setState({
      open: true,
      assetId: assetId ?? initialAsset?.id ?? null,
      initialAsset: initialAsset ?? null,
    });
  }, []);

  const closeAssetDetail = useCallback(() => {
    setState({ open: false, assetId: null, initialAsset: null });
  }, []);

  return (
    <AssetDetailContext.Provider value={{ openAssetDetail, closeAssetDetail }}>
      {children}
      <AssetDetailModal
        isOpen={state.open}
        onClose={closeAssetDetail}
        assetId={state.assetId}
        initialAsset={state.initialAsset}
      />
    </AssetDetailContext.Provider>
  );
};
